import React, { useState, useEffect } from "react";
import { PropertyList } from "../common/PropertyBox";
import { postApiDataAsync, kloader } from "../common/Common";
import Config from "config";

export const PromotionProperties = () => {

    const [PromotionProperties, setPromotionProperties] = useState([]);

    useEffect(() => {
        kloader();

        postApiDataAsync({
            urlPath: "/GetProperties",
            objRequest: {
                filter: {
                    CurrentPageIndex: 1,
                    PageSize: Config.MaxPropertyReturnCountBeforeRandom,
                    PropertyTypes: ["02", "01", "03", "05"],
                    SearchPurposes: ["Promotion30PercentUp"],
                    SourceCodes: ["88"]
                },
            },
        }).then((data) => {
            setPromotionProperties(randomGetNItem(data.Items));
        }).catch(function (error) {
            console.log(error);
            // alertErrorAsync(error);
        }).then(() => {
            kloader();
        });
    }, []);

    function randomGetNItem(array) {
        if (array)
            return array
                .sort(function () {
                    return 0.5 - Math.random();
                })
                .slice(0, Config.MaxPromoPropertyReturnCount);
        return [];
    }

    return (
        <PropertyList list={PromotionProperties} />
    )
}
